import { Route, Switch, useRouteMatch } from "react-router-dom";

import { PayoutSettingsPage } from "./Page";

export function PayoutSettingsRouter() {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.url}>
        <PayoutSettingsPage />
      </Route>
    </Switch>
  );
}
